import { useState } from "react";
import { intl } from "LocaleWrapper";
import { useLazyQuery } from "@apollo/client";

import { Button, PageHeader } from "@cofano/cck";
import { Alert, Grid2 as Grid } from "@mui/material";

import Helmet from "components/helmet/Helmet";
import Language from "components/utils/Language";

import CallCreateEditDialog from "view/calls/components/dialogs/CallCreateEditDialog";

import PushingTugPlanningSelectTugVoyage from "./components/planning/PushingTugPlanningSelectTugVoyage";
import PushingTugPlanningBargeVoyages from "./components/planning/PushingTugPlanningBargeVoyages";
import PushingTugVoyageCalls from "./components/planning/PushingTugPlanningTugCalls";

import { PushingTugVoyage } from "./utils/PushingTugPlanningUtils";

import { GetPushingTugVoyageDocument } from "__generated__/view/pushingtug/graphql/pushingTug.queries.generated";

const PushingTugPlanning = () => {

	const [ dialogOpen, openDialog ] = useState(false);
	const [ voyage, setVoyage ] = useState<PushingTugVoyage | null>(null);

	const [ getPushingTugVoyage, { loading, refetch } ] = useLazyQuery(GetPushingTugVoyageDocument, {
		onCompleted: (result) => setVoyage(result.voyage ?? null),
	});

	return (
		<>
			<PageHeader>
				<PageHeader.Title>
					{intl.formatMessage({ id: "PUSHING_TUG_PLANNING" })}
					<Helmet title={intl.formatMessage({ id: "PUSHING_TUG_PLANNING" })} />
				</PageHeader.Title>

				<PageHeader.Actions>
					<Button onClick={() => openDialog(true)} disabled={!voyage} variant="outlined">
						{Language("CALL_ADD")}
					</Button>
				</PageHeader.Actions>
			</PageHeader>

			<Grid container spacing={3}>
				<Grid size={8}>
					<Grid container spacing={3}>
						<Grid size={12}>
							<PushingTugPlanningSelectTugVoyage
								onChange={voyage => {
									if (voyage) {
										getPushingTugVoyage({
											variables: {
												id: voyage.id,
											},
										});
									} else {
										setVoyage(null);
									}
								}}
							/>
						</Grid>

						<Grid size={12}>
							{voyage ? (
								<PushingTugPlanningBargeVoyages
									key={voyage.id}
									pushingTugVoyage={voyage}
									onPlanningSaved={refetch}
								/>
							) : (
								<Alert severity="warning">
									{intl.formatMessage({ id: "SELECT_PUSHING_TUG_VOYAGE_FIRST" })}
								</Alert>
							)}
						</Grid>
					</Grid>
				</Grid>

				<Grid size={4}>
					<PushingTugVoyageCalls
						voyage={voyage}
						loading={loading}
						refetch={refetch}
					/>
				</Grid>
			</Grid>

			{voyage && (
				<CallCreateEditDialog
					call={null}
					open={dialogOpen}
					voyageId={voyage.id}
					refetch={refetch}
					onClose={() => openDialog(false)}
				/>
			)}
		</>
	);
};

export default PushingTugPlanning;
